module.exports = __webpack_public_path__ + "img/obs_swstg_missing.9d4216d4.svg";